import script from "./BaseTemplateItemTextSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateItemTextSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateItemTextSetting.vue?vue&type=style&index=0&id=62d9856e&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d9856e"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
